// DataContext.js
import React, { createContext, useState } from "react";

// Create a context object
export const DataContext = createContext();

// Create a provider component
export const DataProvider = ({ children }) => {
  const [formData, setFormData] = useState({
    amount: 0,
    interestRate: 0,
    years: 0,
    isSetData: false,
  });

  const updateFormData = (formData) => {
    setFormData({
      amount: formData.amount,
      interestRate: formData.interestRate,
      years: formData.years,
      isSetData: formData.isSetData,
    });
  };

  return (
    <DataContext.Provider value={{ formData, updateFormData }}>
      {children}
    </DataContext.Provider>
  );
};
